const routes = {
  welcome: '/',
  home: '/home',
  signin: '/signin',
  signup: '/signup',
  verifyEmail: '/verify-email',
  completeProfile: '/complete-profile',
  accreditation: '/accreditation',
  requalifyGuide: '/requalify-guide',
  account: '/account',
  profile: '/profile/:userId',
  support: '/support',
  admin: '/admin',
  adminAccreditations: '/admin/accreditations',
  createDive: '/dives/create',
  dives: '/dives',
  diveDetail: '/dives/:id',
  diveRequests: '/dives/:id/requests',
  payment: '/payment/:joinRequestId',
  invites: '/invites',
  terms: '/terms',
  termsOfService: '/terms-of-service'
}

export default routes
